
<template>
    <Layout>
        <b-row>
            <b-col v-if="showMenu" xl="2" lg="3" sm="12" >
                <Menu @back="handleBack"/>
            </b-col>
            <b-col xl="10" lg="9"  sm="12" v-if="showDefaultScreen && showPdfViewer == false">
                <Crumbs v-if="false" />
                <Documents
                @showNotificationDocument="showNotificationDocument"
                @showDistribution="showDistributionHandler"
                @showDirectDistribution="showDirectDistributionHandler"
                @edit="editDoc"
                @showStats="showStatsHandler"
                @showNotifications="showNotificationsTable"
                @showPdfWrapper="handleShowPDF"
                v-if="isEditing == false && showNotifications == false"/>
                <!-- @createNew="newDoc" @showDistribution="showDistributionHandler"-->
                <Edit @back="isEditing = false;" :isNewDocument="isNewDocument" v-if="isEditing"/>
                
            </b-col>
            <b-col cols="12"  sm="12" v-else-if="showDefaultScreen == false && showPdfViewer">
                <ViewDocument @back="showPdfViewer = false" :is_actionable_view="is_actionable_view" :view_id="context_id" />
            </b-col>
            <b-col cols="10" lg="9" sm="12" v-else-if="showDefaultScreen == false && show_notification_doc">
                <ViewNotification @back="handleBack" :is_actionable_view="true" :view_id="context_id" />
            </b-col>
            <b-col cols="12"  sm="12" v-else-if="showDefaultScreen == false && showDistribution">
                <Distribution @back="handleBack" :data="distribution_prop" />
            </b-col>
            <b-col cols="12" sm="12" v-else-if="showDefaultScreen == false && showDirectDistribution">
                <DirectDistribution @back="handleBack" :sop_id="context_id"/>
            </b-col>
            <b-col v-else-if="showDefaultScreen == false && showStats" cols="12" sm="12">
                <Stats/>
            </b-col>
            <b-col v-else>
                <b-button @click="handleBack">Back</b-button>
            </b-col>
        </b-row>
    </Layout>
</template>

<script>
import Stats from '@/components/client_admin/sop/stats.vue'
import { layoutMethods } from '@/state/helpers'
import Menu from '@/components/widgets/green-menu.vue'
import Layout from "../../layouts/main-stripped";
import Crumbs from '@/components/widgets/breadcrumbs.vue';
import Documents from '@/components/client_admin/sop/documentList.vue';
import Edit from '@/components/client_admin/sop/editDocument.vue';
import ViewDocument from '@/components/client_admin/sop/viewDocument.vue';
import ViewNotification from '@/components/client_admin/sop/approveRejectSop.vue';
import Distribution from '@/components/client_admin/sop/distributeDocument.vue';
import DirectDistribution from '@/components/client_admin/sop/directDistribution.vue'
export default {
    data:() => ({
        show_notification_doc: false,
        showStats: false,
        showDistribution: false,
        showDirectDistribution: false,
        showNotifications: false,
        isEditing: false,
        isNewDocument: false,
        hideMenu: false,
        showPdfViewer: false,
        is_actionable_view: false,
        context_id: null,//* document id
        distribution_prop: null,
    }),
    components:{
        Menu, Layout, Crumbs,
        Documents,
        Edit,
        ViewDocument,
        Distribution,
        ViewNotification,
        DirectDistribution,
        Stats,
    },
    computed:{
        showMenu(){
            if(this.showDistribution == true || this.showDirectDistribution == true){
                return false;
            }
            else{
                return true;
            }
        },
        showDefaultScreen(){
            if(this.showStats == false
            && this.showDistribution == false
            && this.showPdfViewer == false
            && this.show_notification_doc == false
            && this.showDirectDistribution == false){
                return true;
            }
            else{
                return false;
            }
        },
    },
    methods:{
        ...layoutMethods,


        //* @events
        showNotificationsTable(payload){
            console.log(payload)
            this.showNotifications = true;
        },
        handleShowPDF(options){
            this.context_id = options.id;
            this.is_actionable_view = options.is_actionable_view;
            this.showPdfViewer = true;
            this.showDistribution = false;
            this.showDirectDistribution = false;
            this.show_notification_doc = false;
        },
        showDistributionHandler(sop_item){
            this.distribution_prop = sop_item;
            this.show_notification_doc = false;
            this.showStats = false;
            this.showPdfViewer = false;
            this.showDirectDistribution = false;
            this.showDistribution = true;
        },
        showStatsHandler(id){
            this.context_id = id;
            //this.hideMenu = false;
            this.showStats = true;
            this.isEditing = false;
            this.showPdfViewer = false;
            this.showDistribution = false;
            this.showDirectDistribution = false;
            this.show_notification_doc = false;

            this.updateMenuType({
                type: 'stats',
                showMenu: false,
                showRoutes: false,
            })
        },
        showDirectDistributionHandler(id){
            this.context_id = id;
            this.distribution_prop = null;
            this.show_notification_doc = false;
            this.showStats = false;
            this.showPdfViewer = false;
            this.showDistribution = false;
            this.showDirectDistribution = true;
            /*this.loadSopData(id)
            .then(()=>{
                console.log('SOP DATA', this.sop_data)
            })*/
        },
        showNotificationDocument(id){
            this.context_id = id;
            this.is_actionable_view = false;
            this.show_notification_doc =  true;
            this.distribution_prop = null;
            this.showStats = false;
            this.showPdfViewer = false;
            this.showDirectDistribution = false;
            this.showDistribution = false;
        },

        handleBack(){
            this.showDocumentsMenu();
            this.isEditing = false;
            this.showStats = false;
            this.showPdfViewer = false;
            this.showDistribution = false;
            this.showDirectDistribution = false;
            this.show_notification_doc = false;
        },
        editDoc(id){
            this.showEditMenu();
            console.log(id);
            this.isNewDocument = false;
            this.isEditing = true;
            this.showDistribution = false;
            this.show_notification_doc = false;
        },

        showDocumentsMenu(){
            this.updateMenuType({
                type: 'clientadmin_documents',
                showRoutes: false,
                showMenu: true,
            })
        },
        showEditMenu(){
            this.hideMenu = false;
            this.updateMenuType({
                type: 'document_edit',
                showMenu: false,
                showRoutes: false,
            })
        },
    },
    mounted(){
        //set emit payload to update the displayed menu
        this.showDocumentsMenu();
    },
    beforeDestroy(){
        this.updateMenuType({
            type: null,
            showMenu: true,
            showRoutes: false,
        })
    },
}
</script>

<style>

</style>
